import { connect } from 'react-redux';
import { changeFave, collectFave, } from '../../CollectionPanel/redux/actionCreators';
import { getIsFavourite } from '../../CollectionPanel/redux/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    isFavourite: !!getIsFavourite(state, ownProps.deviation.deviationId),
}); };
var mapDispatchToProps = {
    onUndo: changeFave,
    onAddToCollection: collectFave,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export default connector;
//# sourceMappingURL=FaveNotification.container.js.map